import { forwardRef } from 'react';

import { Select, MenuItem, Checkbox, Typography } from '@mui/material';

import { graphql } from '../gql';
import { useApiQuery } from '../query/hooks';
import { FormattedMessage } from 'react-intl';

const journey_selectTeam = graphql(`
	query journey_selectTeam {
		listTeam {
			id
			name
		}
	}
`);

type Props = Readonly<{
	teamIds: string[] | undefined;
	value: string[];
}>;

export const SelectJourneyTeam = forwardRef<HTMLDivElement, Props>(({ teamIds, value, ...props }, ref) => {
	const { data: teams } = useApiQuery(journey_selectTeam);

	return (
		<Select
			id={'journey-team'}
			multiple
			ref={ref}
			{...props}
			value={value}
			renderValue={(selected) =>
				selected
					.map((val) => teams?.listTeam.find((team) => team.id === val))
					.map((team) => team?.name)
					.join(', ')
			}
		>
			<MenuItem disabled value={''}>
				<em>
					<FormattedMessage id={'form.select-team-input.placeholder'} />
				</em>
			</MenuItem>

			{teams?.listTeam.map((option) => (
				<MenuItem key={option.id} value={option.id}>
					<Checkbox checked={value.includes(option.id)} />
					<Typography fontSize={14}>{option.name}</Typography>
				</MenuItem>
			))}
		</Select>
	);
});
